// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__39VkR","content":"ManualTimeModal_content__3SKl1"};